<template>
  <div class="con flex flex-column">
    <!-- <div class="con-head">
      <div class="con-head-text flex flex-between">
        <div class="con-head-title flex">
          <span>滚动图</span>
        </div>
      </div>
    </div> -->
    <!-- <ul class="flex flex-middle flex-right">
      <li
        v-for="idx in list.length"
        :class="`flex flex-middle flex-center ${
          active == idx - 1 ? 'active' : ''
        }`"
        :key="`homeNews_Imgs_Indicator_${idx}`"
        @click="setActiveItem(idx - 1)"
      >
        {{ idx }}
      </li>
    </ul> -->
    <el-carousel
      trigger="click"
      :indicator-position="'none'"
      @change="change"
      ref="carouselRef"
    >
      <el-carousel-item
        v-for="(item, index) in list"
        :key="`homeNews_Imgs_${index}`"
      >
        <div class="con-img-box" @click="bannerClick(item)">
          <h3 class="flex">
            <span>{{ item.articleTitle }}</span>
          </h3>
          <img v-img="item.articleImage" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { newsBanner } from "@/api/home";
export default {
  data() {
    return {
      active: 0,
      list: [],
    };
  },
  created() {
    this.getNewsImgs();
  },
  methods: {
    async getNewsImgs() {
      const res = await this.$axios.get(newsBanner);
      this.list = res;
    },
    bannerClick({ articleId }) {
      this.$jump.push({ name: "newsDetail", query: { id: articleId } });
    },
    change(index) {
      this.active = index;
    },
    setActiveItem(index) {
      this.$refs.carouselRef.setActiveItem(index);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/variable";
.con {
  width: 790px;
  position: relative;
  ::v-deep .el-carousel {
    // height: calc(100% - 45px);
    min-height: 340px;
    &__container {
      height: 100%;
      position: absolute;
      width: 100%;
    }
  }
  &-head {
    width: 100%;
    height: 45px;
    text-align: center;
    font-size: 17px;
    position: relative;
    border: 1px solid #e6e6e6;
    border-top: 1px solid $theme-color;
    background: #f4f9fd;
    img {
      width: 100%;
      height: 100%;
    }
    &-text {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      line-height: 45px;
      left: 0;
      top: 0;
      text-align: center;
    }
    &-title {
      span {
        width: 120px;
        background: $theme-color;
        color: #fff;
      }
    }
  }
  ul {
    position: absolute;
    z-index: 3;
    right: 10px;
    bottom: 0;
    width: var(--ul-width);
    height: 48px;
    li {
      list-style: none;
      width: 24px;
      height: 24px;
      border-radius: 12px;
      background: #fff;
      color: var(--dark-black);
      margin-right: 5px;
      cursor: pointer;
      &.active {
        background: #145dc5;
        color: #fff;
      }
    }
  }
  &-img-box {
    position: relative;
    height: 100%;
    cursor: pointer;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
    h3 {
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: 100%;
      height: 48px;
      line-height: 48px;
      background: rgba(#333, 0.5);
      color: #fff;
      span {
        padding-left: 10px;
        width: calc(100% - var(--ul-width) - 10px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
